import { render, staticRenderFns } from "./TbCategoryTabs.vue?vue&type=template&id=4e2bf7d6&scoped=true&"
import script from "./TbCategoryTabs.vue?vue&type=script&lang=js&"
export * from "./TbCategoryTabs.vue?vue&type=script&lang=js&"
import style0 from "./TbCategoryTabs.vue?vue&type=style&index=0&id=4e2bf7d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2bf7d6",
  null
  
)

export default component.exports